export default {
  'GET_LOGIN_ADM' (state, payload) {
    state.user = payload
  },
  'LIST_ITEM_SELECTED_PUSH' (state, payload) {
    for(let key in payload) {
      state.listItemSelected.push(payload[key])
    }
  },
  'LIST_ITEM_SELECTED_DEL' (state, payload) {
    for(let key in payload) {
      state.listItemSelected = state.listItemSelected.filter(i => i.id !== payload[key].id)
    }
  },
  'UPDATE_CONTAS' (state, payload) {
    state.listItemSelected.map(i => {
      i.ativo = payload
      i.status = payload ? 'ativo' : 'desativado'
    })
  },
  'UPDATE_CONTAS_LOG' (state, payload) {
    state.listItemSelected.map(i => {
      i.log = payload
      i.statusLog = payload ? 'ativo' : 'desativado'
    })
  }
}
